import http from "../../http-common";

class TypeFiltersService {
    getTettypeFilters() {
        return http.get('/events-search/type-filters');
    }
}

export default new TypeFiltersService();
